import {Main} from 'src/Layouts';
import {Graphql, YouInvest} from 'src/Api';
import {InvestWithAjBell, Disclaimer} from 'src/Components/Molecules/Card';
import {InstrumentMain, InstrumentInfoBoxes, GrowthRates, DocumentTable} from 'src/Components/Organisms';
import {SideNavigation} from 'src/Components/Molecules/Navigation';
import {getTitle, sendCacheHeaders} from 'src/Utils';
import {KeyStatistics, ValuationStatistics} from './Components/Card';
import moment from 'moment';
import * as Sentry from '@sentry/nextjs';

export default function Ratios({instrumentData}) {

    const getBreadCrumb = () => {
		if (instrumentData) {
			return `${instrumentData.quote.nameShort} (${instrumentData.quote.marketCode}) - Financials and ratios`;
		}
	}

    return <Main title={getTitle(instrumentData, 'Financials and ratios')} nav={instrumentData.nav} breadcrumb={getBreadCrumb()} marketCode={instrumentData.quote.marketCode}>
        <div className="ajb-grid-row padding-bottom-20">
            <div className="ajb-col-2 ajb-col-8-breakpoint padding-top-20 padding-bottom-0-sm">
                <SideNavigation  {...instrumentData} />
                <InvestWithAjBell />
            </div>
            <div className="ajb-col-10 ajb-col-8-breakpoint main-content-wrapper white-bg margin-top-20 padding-20 padding-10-sm">
                <InstrumentMain {...instrumentData} />
                <InstrumentInfoBoxes {...instrumentData} />

                <KeyStatistics {...instrumentData} />
                <ValuationStatistics {...instrumentData} />
                <GrowthRates {...instrumentData.portfolio} formattedDate={moment(instrumentData.portfolio.date, 'YYYY-MM-DD').format('DD/MM/YYYY')} />
                <DocumentTable {...instrumentData} title="Shareholder reports" id="shareholderReports" showPdfText={true} />

                <Disclaimer />
            </div>
        </div>
    </Main>
}

export async function getServerSideProps(context) {

    try { 
        const {marketCode} = context.query;

        const pageData = await YouInvest.getBasicPageData(marketCode);

        const query = `query pageData(
            $identifier: String!
        ) {
            keyStatistics(identifier: $identifier) {
                grossGearing 
                netGearing
                netAssets
                totalAssets
                zStatistic
            }
            portfolio(identifier: $identifier) {
                date
                equityValuation {
                    priceEarnings
                    priceBook
                    priceSales
                    priceCashFlow
                    dividendYieldFactor
                    longProjectedEarningsGrowth
                    historicalEarningsGrowth
                    salesGrowth
                    cashFlowGrowth
                    bookValueGrowth
                    styleBox
                }
                equityValuationCategory {
                    priceEarnings
                    priceBook
                    priceSales
                    priceCashFlow
                    dividendYieldFactor
                    longProjectedEarningsGrowth
                    historicalEarningsGrowth
                    salesGrowth
                    cashFlowGrowth
                    bookValueGrowth
                }
            }
            documents(identifier: $identifier) {
                id
                type
                url
                filingDate
                effectiveDate
                format
            }
        }`;

        const instrumentData = {...pageData, ...(await Graphql.fetch(query, {
            identifier: marketCode
        }))};
        
        sendCacheHeaders(context, pageData);

        return { props: { instrumentData } }
    } catch (e) {
        Sentry.captureException(e);
        return {
            notFound: true
        }
    }
}
